import { __assign, __extends } from "tslib";
import { genericParentIncomingEvents, IframeManager } from '..';
import { Logger } from '../Logger/Logger';
import { noop } from '../utils/noop';
import { normalizeUrl } from '../utils/normalizeUrl';
import { WindowMessenger } from '../WindowMessenger';
export var CloseMethod;
(function (CloseMethod) {
    CloseMethod["Hide"] = "hide";
    CloseMethod["Kill"] = "kill";
})(CloseMethod || (CloseMethod = {}));
var FrameOpener = /** @class */ (function (_super) {
    __extends(FrameOpener, _super);
    function FrameOpener(options) {
        var _this = _super.call(this, undefined, new Logger('FrameOpener')) || this;
        _this._readyUnsubscribe = noop;
        _this._settingsReadyUnsubscribe = noop;
        _this.isReady = false;
        _this.options = __assign({ appendTo: 'body', closeMethod: CloseMethod.Kill }, options);
        var WindowManagerCls = _this.constructor.WindowManagerCls;
        _this.windowManager =
            options.windowManager || new WindowManagerCls(_this.logger);
        return _this;
    }
    FrameOpener.setDefaultWindowManager = function (manager) {
        // tslint:disable-next-line:no-static-this
        this.WindowManagerCls = manager;
    };
    FrameOpener.prototype.open = function (settings, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.displayOnReady, displayOnReady = _c === void 0 ? true : _c;
        var url = this.getFrameUrl(settings);
        var target = this.windowManager.create({
            src: url,
            appendTo: this.options.appendTo,
            frameId: this.options.frameId,
        });
        this.setTarget(target);
        this.once(genericParentIncomingEvents.closeRequest, function () {
            _this.close();
        });
        return this.sendSettings(settings).then(function () {
            displayOnReady && _this.windowManager.show();
        });
    };
    /**
     * Close windowManager.
     */
    FrameOpener.prototype.close = function () {
        switch (this.options.closeMethod) {
            case CloseMethod.Kill:
                this.kill();
                break;
            case CloseMethod.Hide:
                this.windowManager.hide();
                this.emit(this.options.outgoingActions.hidden());
                break;
            default:
                throw new Error("Unsupported close method '".concat(this.options.closeMethod, "'"));
        }
    };
    /**
     * Kill windowManager (close iframe and remove from DOM)
     */
    FrameOpener.prototype.kill = function () {
        this.offAll();
        this.isReady = false;
        this.windowManager.destroy();
    };
    FrameOpener.prototype.sendSettings = function (settings) {
        var _this = this;
        this._readyUnsubscribe();
        this._settingsReadyUnsubscribe();
        return new Promise(function (resolve) {
            var send = function () {
                _this.emit(_this.options.outgoingActions.settings(settings));
                _this._settingsReadyUnsubscribe = _this.once(_this.options.incomingActions.settingsReady, function () {
                    _this.logger.log('iFrame settings are applied');
                    return resolve();
                });
            };
            if (_this.isReady) {
                send();
            }
            _this._readyUnsubscribe = _this.on(_this.options.incomingActions.ready, function () {
                _this.isReady = true;
                send();
            });
        });
    };
    FrameOpener.prototype.getFrameUrl = function (settings) {
        var url = this.options.url;
        return normalizeUrl(typeof url === 'string' ? url : url(settings));
    };
    FrameOpener.WindowManagerCls = IframeManager;
    return FrameOpener;
}(WindowMessenger));
export { FrameOpener };
//# sourceMappingURL=FrameOpener.js.map